import * as React from "react";
import type { SVGProps } from "react";
const SvgPrinter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 9a1 1 0 0 0 2 0zm1-7V1a1 1 0 0 0-1 1zm12 0h1a1 1 0 0 0-1-1zm-1 7a1 1 0 1 0 2 0zM6 19a1 1 0 1 0 0-2zm-4-3H1zm2-7v1zm14 8a1 1 0 1 0 0 2zM6 14v-1a1 1 0 0 0-1 1zm12 0h1a1 1 0 0 0-1-1zm0 8v1a1 1 0 0 0 1-1zM6 22H5a1 1 0 0 0 1 1zM7 9V2H5v7zM6 3h12V1H6zm11-1v7h2V2zM6 17H4v2h2zm-2 0a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 4 19zm-.707-.293A1 1 0 0 1 3 16H1a3 3 0 0 0 .879 2.121zM3 16v-5H1v5zm0-5a1 1 0 0 1 .293-.707L1.879 8.879A3 3 0 0 0 1 11zm.293-.707A1 1 0 0 1 4 10V8a3 3 0 0 0-2.121.879zM4 10h16V8H4zm16 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 20 8zm.707.293A1 1 0 0 1 21 11h2a3 3 0 0 0-.879-2.121zM21 11v5h2v-5zm0 5a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 23 16zm-.293.707A1 1 0 0 1 20 17v2a3 3 0 0 0 2.121-.879zM20 17h-2v2h2zM6 15h12v-2H6zm11-1v8h2v-8zm1 7H6v2h12zM7 22v-8H5v8z"
    />
  </svg>
);
export default SvgPrinter;
